var exports = {
  "kL": "ColorPickerPopover.module__container___RndrWT",
  "ij": "ColorPickerPopover.module__pickerContainer___RndrWT",
  "mo": "ColorPickerPopover.module__pickerContainerWithMargin___RndrWT",
  "og": "ColorPickerPopover.module__pickerWrapper___RndrWT",
  "$n": "ColorPickerPopover.module__colorArea___RndrWT",
  "DN": "ColorPickerPopover.module__colorSlider___RndrWT",
  "NB": "ColorPickerPopover.module__sliderTrack___RndrWT",
  "eo": "ColorPickerPopover.module__colorThumb___RndrWT",
  "WA": "ColorPickerPopover.module__resetButton___RndrWT",
  "px": "ColorPickerPopover.module__resetButtonText___RndrWT",
};

module.exports = exports;
